import { memo, useMemo } from 'react'
import { FormattedMessage } from 'react-intl'
import { Tooltip, styled } from '@mui/material'
import { Typography } from '@carto/meridian-ds/components'
import { CardFooterItemProps } from './CardFooterInterfaces'

const Text = styled(Typography, { shouldForwardProp: (prop) => prop !== 'capitalize' })<{ capitalize?: boolean }>(
  ({ capitalize }) => ({
    display: 'flex',

    ...(capitalize && {
      textTransform: 'capitalize'
    })
  })
)

function CardFooterItemText({
  tooltip,
  text,
  showTextTooltip,
  tooltipTextLabelId,
  tooltipTextLabelValue,
  capitalize
}: CardFooterItemProps & { showTextTooltip?: boolean }) {
  const ItemText = useMemo(() => {
    return () => (
      <Text variant="caption" color="inherit" capitalize={capitalize}>
        {text}
      </Text>
    )
  }, [text, capitalize])

  if (text === null || text === undefined) return null

  if (!tooltip) {
    return <ItemText />
  }

  return (
    <Tooltip
      open={showTextTooltip}
      title={tooltipTextLabelId ? <FormattedMessage id={tooltipTextLabelId} /> : tooltipTextLabelValue}
    >
      <span>
        <ItemText />
      </span>
    </Tooltip>
  )
}

export default memo(CardFooterItemText)
